import { apiRequest } from "../util/apiUtils";

export const getMediaList = async (params) => {
  try {
    const res = await apiRequest("get", `/media/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const folderAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `media/${payload?.id ? "edit" : "create-folder"}`,
      {
        body: payload,
      }
      // "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const fileAddEdit = async (payload, uploadPercentage = () => {}) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `media/${payload?.id ? "edit" : "create-file"}`,
      {
        body: payload,
      },
      "multipart/form-data",
      uploadPercentage
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};
